import { Utility, utility_controller, getTargetContainers, getTargetContainersExceptPageOverlay } from '../utility/utility_controller'
import restoreLoadMore from '../utility/restoreLoadMore'
import { load_visible_images_then_rest_controller } from '../utility/load_visible_images_then_rest'
import load_html5_videos_controller from '../html5video/load_html5_videos_controller'
import union from 'lodash/union'
import intersection from 'lodash/intersection'
import prevnext_controller from '../prevnext/prevnext_controller'
import element_animate_in_on_scroll_controller from '../element_animate_in_on_scroll/element_animate_in_on_scroll'

// Use the global history instance created in history_controller_new.js
// This ensures all modules use the same history instance for proper synchronization
const getHistory = () => window.layHistory

var $grids
const rowsToShowDefaults = { desktop: 3, tablet: 3, phone: 6 }

var getRowsToShow = function (config, device) {
	if (!config || !config[device]) {
		return 0
	}
	var rows = typeof config[device].rowsToShow === 'undefined' ? rowsToShowDefaults[device] : Number(config[device].rowsToShow)
	if (isNaN(rows) || rows < 0) {
		rows = 0
	}
	return rows
}

var getLimitForDevice = function (config, device) {
	var rows = getRowsToShow(config, device)
	if (rows <= 0) {
		return -1
	}
	var colCount = config[device] && typeof config[device].colCount !== 'undefined' ? Number(config[device].colCount) : 1
	if (isNaN(colCount) || colCount < 1) {
		colCount = 1
	}
	return rows * colCount
}

var getRowsShownMultiplier = function ($grid) {
	var attr = Number($grid.attr('data-rows-shown'))
	if (isNaN(attr) || attr < 1) {
		attr = 1
		$grid.attr('data-rows-shown', attr)
	}
	return attr
}

var setRowsShownMultiplier = function ($grid, value) {
	if (isNaN(value) || value < 1) {
		value = 1
	}
	$grid.attr('data-rows-shown', value)
}

var resetRowsShownMultiplier = function ($grid) {
	setRowsShownMultiplier($grid, 1)
}

var applyRowLimit = function ($grid, config) {
	if (!$grid || $grid.length === 0 || !config) {
		return
	}
	var showMoreEnabled = config.showMoreButton === true || config.showMoreButton === 'true'
	var rowsToShow = getRowsToShow(config, Utility.screenSize)
	// Button is inside the grid (not a sibling)
	var $buttonWrap = $grid.find('.lay-thumbnailgrid-load-more-wrap').first()
	var $button = $buttonWrap.length > 0 ? $buttonWrap.find('.lay-thumbnailgrid-load-more').first() : jQuery()
	if (!showMoreEnabled || rowsToShow <= 0) {
		if ($button.length) {
			$button.hide()
		}
		resetRowsShownMultiplier($grid)
		$grid.find('.thumbnail-wrap.hide-loadmore').removeClass('hide-loadmore')
		return
	}
	var multiplier = getRowsShownMultiplier($grid)
	var colCount = config[Utility.screenSize] && typeof config[Utility.screenSize].colCount !== 'undefined' ? Number(config[Utility.screenSize].colCount) : 1
	if (isNaN(colCount) || colCount < 1) {
		colCount = 1
	}
	var maxVisible = rowsToShow * colCount * multiplier
	var visibleCount = 0
	$grid.find('.thumbnail-wrap.hide-loadmore').removeClass('hide-loadmore')
	// Count only items that are not filtered out
	var totalUnfilteredCount = 0
	$grid.find('.thumbnail-wrap').each(function () {
		var $item = jQuery(this)
		if (!$item.hasClass('hide-filtered') && !$item.hasClass('hide-because-limit')) {
			totalUnfilteredCount++
		}
	})
	$grid.find('.thumbnail-wrap').each(function () {
		var $item = jQuery(this)
		if ($item.hasClass('hide-filtered') || $item.hasClass('hide-because-limit')) {
			return
		}
		if (visibleCount < maxVisible) {
			visibleCount++
			$item.removeClass('hide-loadmore')
		} else {
			$item.addClass('hide-loadmore')
		}
	})
	if ($button.length) {
		// Show button only if there are more unfiltered items than currently visible
		if (totalUnfilteredCount > visibleCount) {
			$button.show()
		} else {
			$button.hide()
		}
	}
	if (config.layoutType === 'masonry') {
		var masonry = $grid.data('masonry')
		if (typeof masonry != 'undefined' && masonry !== null) {
			masonry.reloadItems()
			masonry.layout()
			// Re-evaluate button visibility after masonry layout completes
			// Only update button visibility, don't call applyRowLimit again (would cause infinite loop)
			masonry.once('layoutComplete', function () {
				var $buttonWrap = $grid.find('.lay-thumbnailgrid-load-more-wrap').first()
				var $button = $buttonWrap.length > 0 ? $buttonWrap.find('.lay-thumbnailgrid-load-more').first() : jQuery()
				if ($button.length) {
					var totalUnfilteredCount = 0
					var visibleCount = 0
					$grid.find('.thumbnail-wrap').each(function () {
						var $item = jQuery(this)
						if (!$item.hasClass('hide-filtered') && !$item.hasClass('hide-because-limit')) {
							totalUnfilteredCount++
						}
						if (!$item.hasClass('hide-filtered') && !$item.hasClass('hide-because-limit') && !$item.hasClass('hide-loadmore')) {
							visibleCount++
						}
					})
					if (totalUnfilteredCount > visibleCount) {
						$button.show()
					} else {
						$button.hide()
					}
				}
			})
		}
	}
}

var onResize = function () {
	if (typeof $grids != 'undefined') {
		$grids.each(function () {
			var $el = jQuery(this)
			var config = $el.data('config')
			sizeLayout($el, config)
		})
	}
}

var sizeLayout = function ($el, config) {
	var currentDevice = Utility.screenSize

	var colGutter = config[currentDevice].colGutter
	var rowGutter = config[currentDevice].rowGutter
	var colCount = config[currentDevice].colCount

	var rowGutterMu = typeof config[currentDevice].rowGutterMu === 'undefined' ? '%' : config[currentDevice].rowGutterMu
	var colGutterMu = typeof config[currentDevice].colGutterMu === 'undefined' ? '%' : config[currentDevice].colGutterMu

	// took this calculation from "layout_functions.php"
	var gutter_diff = (1 - 1 / colCount) * config[currentDevice].colGutter
	var width = 'calc( 100% / ' + colCount + ' - ' + gutter_diff + colGutterMu + ')'

	var obj = {
		width: width,
	}
	if (rowGutterMu == '%' || config.layoutType == 'masonry') {
		obj['margin-bottom'] = rowGutter + rowGutterMu
	} else {
	}

	$el.find('.thumbnail-wrap').css(obj)

	var layoutType = config.layoutType
	switch (layoutType) {
		case 'masonry':
			$el.find('.lay-thumbnailgrid-gutter-sizer').css('width', colGutter + colGutterMu)
			$el.find('.lay-thumbnailgrid-col-sizer').css('width', width)
			var masonry = $el.data('masonry')
			if (typeof masonry != 'undefined') {
				masonry.layout()
			}
			break
		default:
			// just flexbox
			$el.find('.thumb-collection').css('column-gap', colGutter + colGutterMu)
			$el.find('.thumb-collection').css('row-gap', rowGutter + rowGutterMu)
			break
	}
	// Don't call applyRowLimit for masonry layouts here, as it's already called by applyRowLimit itself
	// and calling it again would create a circular dependency (applyRowLimit -> sizeLayout -> applyRowLimit -> ...)
	if (layoutType !== 'masonry') {
		applyRowLimit($el, config)
	}
}

var initLayoutType = function ($el, config) {
	var currentDevice = Utility.screenSize

	switch (config.layoutType) {
		case 'masonry':
			$el.find('.thumb-collection').append('<div class="lay-thumbnailgrid-gutter-sizer"></div><div class="lay-thumbnailgrid-col-sizer"></div>')

			var elem = $el.find('.thumb-collection')[0]

			var gutter = '.lay-thumbnailgrid-gutter-sizer'
			var colGutterMu = typeof config[currentDevice].colGutterMu === 'undefined' ? '%' : config[currentDevice].colGutterMu
			if (colGutterMu === 'px') {
				gutter = config[currentDevice].colGutter
			}

			var masonry = new Masonry(elem, {
				// options
				itemSelector: '.thumbnail-wrap',
				columnWidth: '.lay-thumbnailgrid-col-sizer',
				gutter: gutter,
				percentPosition: true,

				transitionDuration: 0,
			})
			masonry.once('layoutComplete', function () {
				$el.closest('.col').addClass('masonry-initialized')
			})
			$el.data('masonry', masonry)
			break
		default:
			break
	}
}

var i = function () {
	bindEventsToInitGrids()
	jQuery(window).on('window_width_changed', onResize)
	// otherwise, masonry doesnt position elements correctly for scrollslider:
	window.laytheme.on('scrollslider-initialized', onResize)
	bindOnContentReady()
	bindPageOverlayEvents()
}

var parseHashForFilters = function (hash) {
	// Parse hash to extract category and tag slugs
	// Formats: #category-slug, #tag-slug, #category-slug&tag-slug1&tag-slug2
	var categorySlug = null
	var tagSlugs = []

	if (!hash || hash === '') {
		return { categorySlug: null, tagSlugs: [] }
	}

	// Remove the # if it exists
	hash = hash.replace(/^#/, '')

	// Split by & to separate category and tags
	var parts = hash.split('&')

	for (var i = 0; i < parts.length; i++) {
		var part = parts[i]
		if (part.startsWith('category-')) {
			categorySlug = part.substr(9)
		} else if (part.startsWith('tag-')) {
			tagSlugs.push(part.substr(4))
		}
	}

	return { categorySlug: categorySlug, tagSlugs: tagSlugs }
}

var handleHashChange = function (hash) {
	if ($target != undefined) {
		var $grids = $target.find('.thumbs-collection-region.use-filter, .thumbs-collection-region.use-tags-filter')

		if ($grids.length > 0) {
			$grids.each(function () {
				var $grid = jQuery(this)
				deselectTags($grid)
				var cat_id = false
				var thumbnails_show_hide_data = []

				var filters = parseHashForFilters(hash)

				// Check if "All" filter is active first (it won't be in hash, so check DOM)
				var $allFilter = jQuery(this).find('.lay-thumbnailgrid-filter-anchor[data-slug="all"].lay-filter-active')
				if ($allFilter.length > 0) {
					cat_id = false
				} else if (filters.categorySlug) {
					var $filter = jQuery(this).find('.lay-thumbnailgrid-filter-anchor[data-slug="' + filters.categorySlug + '"]')
					if ($filter.length > 0) {
						cat_id = $filter.attr('data-id')
					}
				} else if (hash == '') {
					// back to default filter!
					var $filter = jQuery('.lay-filter-default')
					if ($filter.length > 0) {
						cat_id = $filter.attr('data-id')
					}
				}

				// Activate tag filters from URL
				if (filters.tagSlugs.length > 0) {
					for (var i = 0; i < filters.tagSlugs.length; i++) {
						var tagSlug = filters.tagSlugs[i]
						var $tagBubble = $grid.find('.tag-bubble[data-tag_slug="' + tagSlug + '"]')
						if ($tagBubble.length > 0) {
							$tagBubble.addClass('lay-tag-active')
						}
					}
				}

				thumbnails_show_hide_data = get_thumbnails_show_hide_data($grid, cat_id)
				filterContent($grid, cat_id, true, thumbnails_show_hide_data)

				if (cat_id !== false || filters.tagSlugs.length > 0) {
					showHideTagBubbles($grid, cat_id, thumbnails_show_hide_data)
				}
			})
		}
	}
}

var showHideTagBubbles = function ($grid, cat_id, thumbnails_show_hide_data) {
	cat_id = cat_id !== false ? parseInt(cat_id, 10) : false
	var config = $grid.data('config')
	resetRowsShownMultiplier($grid)

	var showCatFilter = false
	if (config != false && config.hasOwnProperty('showfilter')) {
		showCatFilter = config.showfilter
	}
	var tagFilterBehaviour = 'OR'
	if (config != false && config.hasOwnProperty('tagFilterBehaviour')) {
		tagFilterBehaviour = config.tagFilterBehaviour
	}

	var showtagfilter = false
	if (config != false && config.hasOwnProperty('showtagfilter')) {
		showtagfilter = config.showtagfilter
	}

	var all_available_tag_ids_for_current_cat = []
	// cat_id can be false if were using showAllProjects
	if (cat_id != false) {
		if (showCatFilter == true) {
			// hide bubbles that have no content in grid that could be filtered
			$grid.find('.thumbnail-wrap').each(function () {
				var cat_ids = utility_controller.parseIdsString(jQuery(this).attr('data-filterid'))
				// for "All" filter:
				cat_ids.push(0)

				if (cat_ids.indexOf(cat_id) !== -1) {
					var thumbnail_tag_ids_string = jQuery(this).attr('data-tags')
					var thumbnail_tag_ids = utility_controller.parseIdsString(thumbnail_tag_ids_string)
					for (var index = 0; index < thumbnail_tag_ids.length; index++) {
						var id = thumbnail_tag_ids[index]
						if (all_available_tag_ids_for_current_cat.indexOf(id) == -1) {
							all_available_tag_ids_for_current_cat.push(id)
						}
					}
				}
			})
		} else if (showtagfilter == true && showCatFilter == false) {
			// there is no category filter so just remove tag filters that we dont need from dom

			$grid.find('.thumbnail-wrap').each(function () {
				var thumbnail_tag_ids_string = jQuery(this).attr('data-tags')
				var thumbnail_tag_ids = utility_controller.parseIdsString(thumbnail_tag_ids_string)
				for (var index = 0; index < thumbnail_tag_ids.length; index++) {
					var id = thumbnail_tag_ids[index]
					if (all_available_tag_ids_for_current_cat.indexOf(id) == -1) {
						all_available_tag_ids_for_current_cat.push(id)
					}
				}
			})

			$grid.find('.tag-bubble:not(.deselect-tags)').each(function () {
				var tag_id = parseInt(jQuery(this).attr('data-tag_id'), 10)
				if (all_available_tag_ids_for_current_cat.indexOf(tag_id) == -1) {
					jQuery(this).remove()
				}
			})
		}
	} else {
		if (showtagfilter == true) {
			// if showAllProjects is true, then cat_id is false
			$grid.find('.thumbnail-wrap').each(function () {
				var thumbnail_tag_ids_string = jQuery(this).attr('data-tags')
				var thumbnail_tag_ids = utility_controller.parseIdsString(thumbnail_tag_ids_string)
				for (var index = 0; index < thumbnail_tag_ids.length; index++) {
					var id = thumbnail_tag_ids[index]
					if (all_available_tag_ids_for_current_cat.indexOf(id) == -1) {
						all_available_tag_ids_for_current_cat.push(id)
					}
				}
			})

			$grid.find('.tag-bubble:not(.deselect-tags)').each(function () {
				var tag_id = parseInt(jQuery(this).attr('data-tag_id'), 10)
				if (all_available_tag_ids_for_current_cat.indexOf(tag_id) == -1) {
					jQuery(this).remove()
				}
			})
		}
	}

	var $activeBubbles = $grid.find('.tag-bubble.lay-tag-active')
	if ($activeBubbles.length > 0) {
		// show "clear all" button
		$grid.find('.deselect-tags').css('display', '').removeClass('lay-filter-hidden')
	} else {
		$grid.find('.deselect-tags').addClass('lay-filter-hidden')
	}

	switch (tagFilterBehaviour) {
		case 'AND':
			// when tagFilterBehaviour is "AND" and at least one tag bubble is selected,
			// only show tag bubbles that would create results when clicked on / combined with currently selected tag(s)
			// first: get currently selected tag ids

			var $activeBubbles = $grid.find('.tag-bubble.lay-tag-active')
			if ($activeBubbles.length > 0) {
				var activeTagIds = []
				$activeBubbles.each(function () {
					activeTagIds.push(parseInt(jQuery(this).attr('data-tag_id'), 10))
				})

				// then look at the currently filtered thumbnails. which tag ids do they have?

				var tagIdsOfCurrentlyFilteredThumbnails = []
				for (var index = 0; index < thumbnails_show_hide_data.length; index++) {
					var obj = thumbnails_show_hide_data[index]
					if (obj.show == true) {
						tagIdsOfCurrentlyFilteredThumbnails = union(obj.ids, tagIdsOfCurrentlyFilteredThumbnails)
					}
				}

				// First hide all tags, then show only the available ones
				if (showCatFilter || cat_id === false) {
					$grid.find('.tag-bubble:not(.deselect-tags)').css('display', 'none')
				}

				for (var index = 0; index < all_available_tag_ids_for_current_cat.length; index++) {
					var tag_id = all_available_tag_ids_for_current_cat[index]

					if (activeTagIds.length > 0 && intersection(activeTagIds, tagIdsOfCurrentlyFilteredThumbnails).length > 0 && tagIdsOfCurrentlyFilteredThumbnails.indexOf(tag_id) != -1) {
						$grid.find('.tag-bubble[data-tag_id="' + tag_id + '"]').css('display', '')
					} else if (showCatFilter || cat_id === false) {
						$grid.find('.tag-bubble[data-tag_id="' + tag_id + '"]').css('display', 'none')
					}
				}
			} else {
				// No active tags - show all available tag bubbles for current category/All
				if (showCatFilter || cat_id === false) {
					$grid.find('.tag-bubble:not(.deselect-tags)').css('display', 'none')

					for (var index = 0; index < all_available_tag_ids_for_current_cat.length; index++) {
						var tag_id = all_available_tag_ids_for_current_cat[index]

						$grid.find('.tag-bubble[data-tag_id="' + tag_id + '"]').css('display', '')
					}
				} else if (!showCatFilter) {
					// if there is no category filter and no active tags, show all tag bubbles. probably, the clear all button was clicked.
					$grid.find('.tag-bubble:not(.deselect-tags)').css('display', '')
				}
			}
			break
		case 'OR':
		default:
			if (showCatFilter || cat_id === false) {
				// Hide all tag bubbles first
				$grid.find('.tag-bubble:not(.deselect-tags)').css('display', 'none')

				// Show only available tag bubbles
				for (var index = 0; index < all_available_tag_ids_for_current_cat.length; index++) {
					var tag_id = all_available_tag_ids_for_current_cat[index]
					$grid.find('.tag-bubble[data-tag_id="' + tag_id + '"]').css('display', '')
				}
			}
			break
	}
}

var deselectTags = function ($grid, $tag_bubble) {
	var $tags_wrap = $grid.find('.lay-thumbnailgrid-tagfilter')
	// var $tags_results_wrap = $grid.find('.lay-thumbnailgrid-tagfilter-active-filters');

	if ($tag_bubble != undefined && $tag_bubble != false && $tag_bubble.length > 0) {
		// deselect one tag
		$tag_bubble.removeClass('lay-tag-active')
	} else {
		// deselect all tags
		$grid.find('.tag-bubble').removeClass('lay-tag-active')
	}
	// sort:
	// https://stackoverflow.com/a/282940
	var $bubbles = $tags_wrap.find('.tag-bubble')
	var itemsArr = []
	var config = $grid.data('config')
	var reorder_tags = config != false && config.hasOwnProperty('reorder_tags') ? config.reorder_tags : true
	if (reorder_tags) {
		$bubbles.each(function () {
			if (!jQuery(this).hasClass('lay-tag-active')) {
				var ix = jQuery(this).attr('data-ix')
				itemsArr.push([this, ix])
			}
		})

		// sort
		itemsArr.sort(function (a, b) {
			return a[1] == b[1] ? 0 : a[1] > b[1] ? 1 : -1
		})

		// put sorted html in tagswrap

		var markup = ''

		// first "clear all button"
		if ($tags_wrap.find('.deselect-tags').length > 0) {
			markup += $tags_wrap.find('.deselect-tags')[0].outerHTML
		}

		// then put active bubbles in markup
		$tags_wrap.find('.lay-tag-active').each(function () {
			markup += this.outerHTML
		})

		// then the inactive ones
		for (var index = 0; index < itemsArr.length; index++) {
			if (!itemsArr[index][0].classList.contains('deselect-tags')) {
				markup += itemsArr[index][0].outerHTML
			}
		}

		$tags_wrap.html(markup)
	}
}

var $target = undefined
var $lastTarget = undefined
var lastTypeOfContentThatIsReady = undefined
var bindOnContentReady = function () {
	window.laytheme.on('content_ready', function (typeOfContentThatIsReady) {
		$target = getTargetContainersExceptPageOverlay(typeOfContentThatIsReady)
		initGrids($target)

		lastTypeOfContentThatIsReady = typeOfContentThatIsReady
		$lastTarget = $target
	})

	window.laytheme.on('overlayshown', function ($newTarget) {
		$target = $newTarget
		// only do all this once per page overlay:
		if ($target.hasClass('lay-overlay-was-opened-at-least-once')) {
			return
		}
		initGrids($target)
	})

	window.laytheme.on('overlayhidden', function () {
		$target = getTargetContainersExceptPageOverlay(lastTypeOfContentThatIsReady)
		// dont need to do initGrids again, because this page's thumbnailgrid was already initialized
	})
}

var bindPageOverlayEvents = function () {}

var initGrids = function ($target) {
	$grids = $target.find('.thumbs-collection-region')
	var $grids2 = $grids.not('.initialized')

	if ($grids2.length > 0) {
		$grids2.each(function () {
			var $grid = jQuery(this)
			var config = $grid.data('config')
			var cat_id = false
			var thumbnails_show_hide_data = []

			// Log element detection early
			var elementType = restoreLoadMore.getElementType($grid)
			var elementId = restoreLoadMore.getElementId($grid)

			maybeRandomize($grid, config)
			initLayoutType($grid, config)
			sizeLayout($grid, config)
			var hash = window.location.hash

			// Parse hash for both category and tag filters
			var filters = parseHashForFilters(hash)
			var hasFiltersInUrl = filters.categorySlug || filters.tagSlugs.length > 0

			if (hasFiltersInUrl && (jQuery(this).hasClass('use-filter') || jQuery(this).hasClass('use-tags-filter'))) {
				// Handle category filter from URL
				if (filters.categorySlug) {
					var $filter = jQuery(this).find('.lay-thumbnailgrid-filter-anchor[data-slug="' + filters.categorySlug + '"]')
					if ($filter.length > 0) {
						cat_id = parseInt($filter.attr('data-id'), 10)
					}
				}

				// Handle tag filters from URL
				if (filters.tagSlugs.length > 0) {
					var reorder_tags = config != false && config.hasOwnProperty('reorder_tags') ? config.reorder_tags : true
					var $tags_wrap = $grid.find('.lay-thumbnailgrid-tagfilter')

					// First, activate all tags from URL
					for (var i = 0; i < filters.tagSlugs.length; i++) {
						var tagSlug = filters.tagSlugs[i]
						var $tagBubble = $grid.find('.tag-bubble[data-tag_slug="' + tagSlug + '"]')
						if ($tagBubble.length > 0) {
							$tagBubble.addClass('lay-tag-active')
						}
					}

					// Then reorder tags to the front in the order they appear in the URL
					if (reorder_tags) {
						var $deselectBtn = $grid.find('.deselect-tags')

						// Iterate through URL tag order and move each tag to the front
						for (var i = 0; i < filters.tagSlugs.length; i++) {
							var tagSlug = filters.tagSlugs[i]
							var $tagBubble = $grid.find('.tag-bubble[data-tag_slug="' + tagSlug + '"]')

							if ($tagBubble.length > 0) {
								if (i === 0) {
									// First tag goes after deselect button or at the start
									if ($deselectBtn.length > 0) {
										$tagBubble.insertAfter($deselectBtn)
									} else {
										$tags_wrap.prepend($tagBubble)
									}
								} else {
									// Subsequent tags go after the previous tag in URL order
									var prevTagSlug = filters.tagSlugs[i - 1]
									var $prevTagBubble = $grid.find('.tag-bubble[data-tag_slug="' + prevTagSlug + '"]')
									if ($prevTagBubble.length > 0) {
										$tagBubble.insertAfter($prevTagBubble)
									}
								}
							}
						}
					}
				}

				thumbnails_show_hide_data = get_thumbnails_show_hide_data($grid)
				filterContent($grid, cat_id, false, thumbnails_show_hide_data)
			} else {
				cat_id = config.cat_id
				var showAllProjects = config != false && config.hasOwnProperty('showAllProjects') ? config.showAllProjects : false
				cat_id = showAllProjects ? false : cat_id

				// When showAllProjects is true, we need to call filterContent to show all thumbnails
				if (showAllProjects) {
					thumbnails_show_hide_data = get_thumbnails_show_hide_data($grid)
					filterContent($grid, cat_id, false, thumbnails_show_hide_data)
				} else {
					// limit thumbnails is called in "filterContent", but here we dont call "filterContent"
					limitThumbnails($grid, config)
					applyRowLimit($grid, config)
				}
			}

			if (cat_id !== false || filters.tagSlugs.length > 0) {
				// hide tag bubbles that are not available
				// Recalculate after filterContent has updated the DOM
				thumbnails_show_hide_data = get_thumbnails_show_hide_data($grid)
				showHideTagBubbles($grid, cat_id, thumbnails_show_hide_data)
			}
			$grid.addClass('initialized')
		})

		bindClearAllTagsClick()
		bindFilterClick()
		bindTagFilterClick()

		$grids2.each(function () {
			var $el = jQuery(this)
			var config = $el.data('config')
			initLayoutType($el, config)
			sizeLayout($el, config)
			jQuery(this).addClass('sized')
			loadVideos($el)
		})

		// lazySizes.autoSizer.checkElems()
		// Restore load more state from sessionStorage AFTER filters are applied
		// This ensures restore works with the filtered set of items
		$grids2.each(function () {
			var $grid = jQuery(this)
			var elementType = restoreLoadMore.getElementType($grid)
			var elementId = restoreLoadMore.getElementId($grid)

			if (elementType && elementId) {
				if (!restoreLoadMore.isRememberEnabled()) {
					restoreLoadMore.clearLoadMoreState(elementType, elementId)
				} else {
					var savedState = restoreLoadMore.getLoadMoreState(elementType, elementId)

					if (savedState && savedState.multiplier && savedState.multiplier > 1) {
						setRowsShownMultiplier($grid, savedState.multiplier)
						// Re-apply row limits with the restored multiplier
						var config = $grid.data('config')
						if (config) {
							applyRowLimit($grid, config)
						}
					} else {
					}
				}
			} else {
				console.warn('[ThumbnailGrid Init] Could not restore state - missing elementType or elementId:', {
					elementType: elementType,
					elementId: elementId,
				})
			}
		})

		utility_controller.setImageSizesAttribute($grids2)
	}
}

var loadVideos = function ($el) {
	// When normal lazyloading is active, load newly revealed filtered videos
	// immediately in instant-image mode. Browser-specific eager fallback already
	// hydrates every video and removes the video-lazyload class before this runs.
	if (layData.image_loading == 'instant_load') {
		$el.find('video.video-lazyload.video-inside-thumbnailgrid-with-filter').each(function () {
			if (jQuery(this).is(':visible')) {
				var $wrap = jQuery(this).closest('.thumbnail-wrap')
				if (!$wrap.hasClass('hide-filtered') && !$wrap.hasClass('hide-because-limit') && !$wrap.hasClass('hide-loadmore')) {
					load_html5_videos_controller.loadSpecificVideo(this)
				}
			}
		})
	}
}

var maybeRandomize = function ($el, config) {
	if (config.randomorder && !$el.hasClass('was-randomized')) {
		var unshuffled = $el.find('.thumbnail-wrap').toArray()

		let shuffled = unshuffled
			.map((value) => ({ value, sort: Math.random() }))
			.sort((a, b) => a.sort - b.sort)
			.map(({ value }) => value)
		$el.find('.thumb-collection').html(shuffled)
		$el.addClass('was-randomized')
	}
}

var limitThumbnails = function ($grid, config) {
	if ($grid.hasClass('use-filter') || $grid.hasClass('use-tags-filter')) {
		if (config.hasOwnProperty('limitThumbnails') && config.limitThumbnails > 0) {
			let index2 = 0
			// when only using a tag filter, at load, no tag is pre-selected. so i cant look for ".show-filtered"
			let hasBeenFiltered = $grid.find('.show-filtered').length > 0

			$grid.find('.thumbnail-wrap').each(function () {
				if (jQuery(this).hasClass('show-filtered') || !hasBeenFiltered) {
					index2++
					if (index2 > config.limitThumbnails) {
						jQuery(this).addClass('hide-because-limit')
					} else {
						jQuery(this).removeClass('hide-because-limit')
					}
				}
			})
		}
	}
}

var bindClearAllTagsClick = function () {
	jQuery(document).off('tap', '.lay-thumbnailgrid-tagfilter .deselect-tags')
	jQuery(document).on('tap', '.lay-thumbnailgrid-tagfilter .deselect-tags', function (e) {
		jQuery(this).addClass('lay-filter-hidden')
		var $grid = jQuery(e.target.closest('.thumbs-collection-region'))
		deselectTags($grid)

		// Update URL to remove tag filters
		var newHash = buildHashFromFilters($grid)
		var obj = {
			type: jQuery('body').attr('data-type'),
			id: jQuery('body').attr('data-id'),
			catid: utility_controller.parseIdsString(jQuery('body').attr('data-catid')),
			slug: jQuery('body').attr('data-slug'),
			title: document.title,
		}
		var url = window.location.href.split('#')[0]
		// Use history.replace() for better cross-browser support (Safari, mobile)
		var urlObj = new URL(url + newHash)
		getHistory().replace(urlObj.pathname + urlObj.search + urlObj.hash, obj)

		var $active = $grid.find('.lay-thumbnailgrid-filter-anchor.lay-filter-active')
		var cat_id = false
		if ($active.length > 0) {
			cat_id = parseInt($grid.find('.lay-thumbnailgrid-filter-anchor.lay-filter-active').attr('data-id'), 10)
		}

		var config = $grid.data('config')
		if (cat_id === false) {
			cat_id = parseInt(config.cat_id, 10)
		}

		var thumbnails_show_hide_data = get_thumbnails_show_hide_data($grid)

		filterContent($grid, cat_id, true, thumbnails_show_hide_data)

		var tagFilterBehaviour = 'OR'
		if (config != false && config.hasOwnProperty('tagFilterBehaviour')) {
			tagFilterBehaviour = config.tagFilterBehaviour
			tagFilterBehaviour = tagFilterBehaviour.toUpperCase()
		}
		// show tag bubbles again
		if (tagFilterBehaviour == 'AND') {
			showHideTagBubbles($grid, cat_id, thumbnails_show_hide_data)
		}
	})
}

var buildHashFromFilters = function ($grid) {
	// Build hash from active category and tag filters
	var hash = ''

	// Get active category
	var $activeCategory = $grid.find('.lay-thumbnailgrid-filter-anchor.lay-filter-active')
	if ($activeCategory.length > 0) {
		var catSlug = $activeCategory.attr('data-slug')
		if (catSlug && catSlug !== 'all') {
			hash = '#category-' + catSlug
		}
	}

	// Get active tags
	var tagSlugs = []
	$grid.find('.tag-bubble.lay-tag-active').each(function () {
		var tagSlug = jQuery(this).attr('data-tag_slug')
		if (tagSlug) {
			tagSlugs.push('tag-' + tagSlug)
		}
	})

	// Build final hash
	if (tagSlugs.length > 0) {
		if (hash) {
			// Append tags to category
			hash += '&' + tagSlugs.join('&')
		} else {
			// Only tags, no category
			hash = '#' + tagSlugs.join('&')
		}
	}

	return hash
}

var bindTagFilterClick = function () {
	jQuery(document).off('tap', '.lay-thumbnailgrid-tagfilter .tag-bubble:not(.deselect-tags)')
	jQuery(document).on('tap', '.lay-thumbnailgrid-tagfilter .tag-bubble:not(.deselect-tags)', function (e) {
		var $grid = jQuery(e.target.closest('.thumbs-collection-region'))
		var $tag_bubble = jQuery(this)
		var $tags_wrap = $grid.find('.lay-thumbnailgrid-tagfilter')
		var config = $grid.data('config')
		var reorder_tags = config != false && config.hasOwnProperty('reorder_tags') ? config.reorder_tags : true
		var singleTagSelectable = config != false && config.hasOwnProperty('singleTagSelectable') && config.singleTagSelectable === true
		// var $tags_results_wrap = $grid.find('.lay-thumbnailgrid-tagfilter-active-filters');
		if (!$tag_bubble.hasClass('lay-tag-active')) {
			if (singleTagSelectable) {
				$tags_wrap.find('.tag-bubble.lay-tag-active:not(.deselect-tags)').removeClass('lay-tag-active')
			}
			if (reorder_tags) {
				var $last_active_tag = $tags_wrap.find('.lay-tag-active').last()
				if ($last_active_tag.length > 0) {
					$tag_bubble.insertAfter($last_active_tag)
				} else {
					if ($grid.find('.deselect-tags').length > 0) {
						$tag_bubble.insertAfter($grid.find('.deselect-tags'))
					} else {
						$tags_wrap.prepend($tag_bubble)
					}
				}
			}
			$tag_bubble.addClass('lay-tag-active')
			// scroll to on mobile one line
			var oneline = $grid[0].querySelector('.lay-thumbnailgrid-tagfilter.mobile-one-line')

			var reorder = true
			if (config.hasOwnProperty('reorder_tags')) {
				reorder = config.reorder_tags
			}

			if (oneline && reorder) {
				oneline.scrollTo({
					top: 0,
					left: 0,
					behavior: 'smooth',
				})
			}
		} else {
			deselectTags($grid, $tag_bubble)
		}

		// Update URL with category and tag filters
		var newHash = buildHashFromFilters($grid)
		var obj = {
			type: jQuery('body').attr('data-type'),
			id: jQuery('body').attr('data-id'),
			catid: utility_controller.parseIdsString(jQuery('body').attr('data-catid')),
			slug: jQuery('body').attr('data-slug'),
			title: document.title,
		}
		var url = window.location.href.split('#')[0]
		// Use history.replace() for better cross-browser support (Safari, mobile)
		var urlObj = new URL(url + newHash)
		getHistory().replace(urlObj.pathname + urlObj.search + urlObj.hash, obj)

		var $active = $grid.find('.lay-thumbnailgrid-filter-anchor.lay-filter-active')
		var cat_id = false
		if ($active.length > 0) {
			cat_id = parseInt($grid.find('.lay-thumbnailgrid-filter-anchor.lay-filter-active').attr('data-id'), 10)
		}

		var thumbnails_show_hide_data = get_thumbnails_show_hide_data($grid)
		filterContent($grid, cat_id, true, thumbnails_show_hide_data)
		showHideTagBubbles($grid, cat_id, thumbnails_show_hide_data)
	})
}

var bindFilterClick = function () {
	jQuery(document).off('tap', '.lay-thumbnailgrid-filter-anchor')
	jQuery(document).on('tap', '.lay-thumbnailgrid-filter-anchor', function (e) {
		var $grid = jQuery(e.target).closest('.thumbs-collection-region')

		if (!jQuery(this).hasClass('lay-filter-active')) {
			// Deselect tags first (category change resets tags)
			deselectTags($grid)

			// Set category as active
			$grid.find('.lay-filter-active').removeClass('lay-filter-active')
			jQuery(this).addClass('lay-filter-active')

			// Get the clicked category ID
			var clickedCatId = jQuery(this).attr('data-id')
			var clickedSlug = jQuery(this).attr('data-slug')

			// Build new hash (will only have category, no tags since we deselected them)
			var newHash = buildHashFromFilters($grid)

			// Replace history state with the new hash
			var obj = {
				type: jQuery('body').attr('data-type'),
				id: jQuery('body').attr('data-id'),
				catid: utility_controller.parseIdsString(jQuery('body').attr('data-catid')),
				slug: jQuery('body').attr('data-slug'),
				title: document.title,
			}
			var url = window.location.href.split('#')[0]
			// Use history.replace() for better cross-browser support (Safari, mobile)
			var urlObj = new URL(url + newHash)
			getHistory().replace(urlObj.pathname + urlObj.search + urlObj.hash, obj)

			// If "All" was clicked (slug is 'all'), pass cat_id as false to show all
			var catIdToFilter = clickedSlug === 'all' || clickedCatId === '0' ? false : parseInt(clickedCatId, 10)
			var thumbnails_show_hide_data = get_thumbnails_show_hide_data($grid, catIdToFilter)

			filterContent($grid, catIdToFilter, true, thumbnails_show_hide_data)

			// Always call showHideTagBubbles to update tag bubble visibility
			showHideTagBubbles($grid, catIdToFilter, thumbnails_show_hide_data)
		} else if (jQuery(e.delegateTarget).find('.lay-tag-active').length > 0) {
			// reset tag filter!
			deselectTags($grid)
			var newHash = buildHashFromFilters($grid)
			var obj = {
				type: jQuery('body').attr('data-type'),
				id: jQuery('body').attr('data-id'),
				catid: utility_controller.parseIdsString(jQuery('body').attr('data-catid')),
				slug: jQuery('body').attr('data-slug'),
				title: document.title,
			}
			var url = window.location.href.split('#')[0]
			// Use history.replace() for better cross-browser support (Safari, mobile)
			var urlObj = new URL(url + newHash)
			getHistory().replace(urlObj.pathname + urlObj.search + urlObj.hash, obj)

			handleHashChange(newHash)
		}
	})
}

// mutates elements array in place, no need to return array
var sortByVisual = function (elements) {
	// Sort elements row by row (top to bottom, then left to right within each row)
	elements.sort(function (a, b) {
		var rectA = a.getBoundingClientRect()
		var rectB = b.getBoundingClientRect()

		// First prioritize by top position (row)
		var topDiff = rectA.top - rectB.top
		if (Math.abs(topDiff) > 100) {
			// 10px tolerance for row grouping
			return topDiff
		}

		// If elements are in the same row (within 100px), sort by left position
		return rectA.left - rectB.left
	})
}

var reorderThumbnailsForCategory = function ($grid, cat_id) {
	var config = $grid.data('config')
	if (!config || !config.categoryProjectOrders) {
		return
	}

	var $collection = $grid.find('.thumb-collection').first()
	var originalOrder = $grid.data('originalThumbnailOrder')
	if (!Array.isArray(originalOrder)) {
		originalOrder = $collection.children('.thumbnail-wrap').toArray()
		$grid.data('originalThumbnailOrder', originalOrder)
	}

	var orderedThumbnails = originalOrder.slice()
	var categoryOrder = cat_id !== false ? config.categoryProjectOrders[String(cat_id)] : null

	if (Array.isArray(categoryOrder)) {
		var positions = {}
		categoryOrder.forEach(function (postId, index) {
			positions[String(postId)] = index
		})

		orderedThumbnails.sort(function (a, b) {
			var aId = String(jQuery(a).find('.thumb[data-id]').first().attr('data-id'))
			var bId = String(jQuery(b).find('.thumb[data-id]').first().attr('data-id'))
			var aPosition = Object.prototype.hasOwnProperty.call(positions, aId) ? positions[aId] : Number.MAX_SAFE_INTEGER
			var bPosition = Object.prototype.hasOwnProperty.call(positions, bId) ? positions[bId] : Number.MAX_SAFE_INTEGER

			if (aPosition === bPosition) {
				return originalOrder.indexOf(a) - originalOrder.indexOf(b)
			}
			return aPosition - bPosition
		})
	}

	var $firstLayoutHelper = $collection.children().not('.thumbnail-wrap').first()
	if ($firstLayoutHelper.length > 0) {
		$firstLayoutHelper.before(orderedThumbnails)
	} else {
		$collection.append(orderedThumbnails)
	}
}

var filterContent = function ($grid, cat_id, animate = true, thumbnails_show_hide_data = []) {
	$grid.find('.lay-filter-active').removeClass('lay-filter-active')
	if (cat_id !== false) {
		$grid.find('.lay-thumbnailgrid-filter-anchor[data-id="' + cat_id + '"]').addClass('lay-filter-active')
		prevnext_controller.useCatIdForSameCategoryPrevNext(cat_id)
	} else {
		// cat_id is false, which means "All" - add active class to "All" filter if it exists
		var $allFilter = $grid.find('.lay-thumbnailgrid-filter-anchor[data-slug="all"]')
		if ($allFilter.length > 0) {
			$allFilter.addClass('lay-filter-active')
		}
		prevnext_controller.useCatIdForSameCategoryPrevNext(null)
	}
	var $thumbs = $grid.find('.thumbnail-wrap')
	var config = $grid.data('config')

	// Hide Load More button immediately when filtering starts
	var $buttonWrap = $grid.find('.lay-thumbnailgrid-load-more-wrap').first()
	if ($buttonWrap.length === 0) {
		$buttonWrap = $grid.nextAll('.lay-thumbnailgrid-load-more-wrap').first()
	}
	var $button = $buttonWrap.length > 0 ? $buttonWrap.find('.lay-thumbnailgrid-load-more').first() : jQuery()
	if ($button.length > 0) {
		$button.hide()
	}

	// Abort any ongoing filter animations
	var existingTimeout1 = $grid.data('filterTimeout1')
	var existingTimeout2 = $grid.data('filterTimeout2')
	if (existingTimeout1) {
		clearTimeout(existingTimeout1)
		$grid.removeData('filterTimeout1')
	}
	if (existingTimeout2) {
		clearTimeout(existingTimeout2)
		$grid.removeData('filterTimeout2')
	}
	// Clean up any animation classes from previous animations
	$grid.removeClass('lay-transition')
	$thumbs.find('.thumb').css('transitionDelay', '')

	// Scroll-animation grids (any mode — scrub OR non-scrub timed) always
	// use the opacity-on-collection fade rather than the legacy per-thumb
	// .below class fade. Reasons:
	//   - The .below CSS rule (.thumb.below { opacity: 0 }) is applied via
	//     class toggling that intentionally skips `.no-animate-in-on-scroll`
	//     items — so for scroll-anim items it produces no fade at all.
	//   - The collection-opacity fade is uniform: it transitions the whole
	//     grid's opacity, which works regardless of per-item scroll-anim
	//     transforms (which live on inner wraps).
	//   - In non-scrub mode, the fade-in window is also when newly-shown
	//     items reset to 'idle' (via thumbnailGridWasFiltered) and
	//     animate in via their effects.
	var usesScrollAnim = $grid.find('.thumbnail-wrap > .lay-scroll-anim-wrap').length > 0

	if ((layData.tgf_transition == 'fade_out_fade_in' || usesScrollAnim) && animate) {
		$grid.addClass('lay-transition')
		$grid.find('.thumb-collection').css('opacity', 0)
		var timeout1 = setTimeout(function () {
			reorderThumbnailsForCategory($grid, cat_id)
			showHideThumbnails(thumbnails_show_hide_data)
			limitThumbnails($grid, config)
			var $filteredThumbs = $grid.find('.show-filtered .thumb')
			// re-layout
			switch (config.layoutType) {
				case 'masonry':
					sizeLayout($grid, config)
					break
				default:
					initLayoutType($grid, config)
					sizeLayout($grid, config)
					break
			}
			utility_controller.setImageSizesAttribute($grid)
			// Reset Load More multiplier and re-evaluate Load More button visibility after filtering
			resetRowsShownMultiplier($grid)
			applyRowLimit($grid, config)
			//waitUntilInviewImagesHaveLoaded($filteredThumbs, function () {
			// show
			$grid.find('.thumb-collection').css('opacity', 1)
			var timeout2 = setTimeout(function () {
				$grid.removeClass('lay-transition')
				$grid.removeData('filterTimeout2')
				// Re-evaluate button visibility after animation completes to ensure it's shown if needed
				applyRowLimit($grid, config)
			}, 500)
			$grid.data('filterTimeout2', timeout2)
			//})
			loadVideos($grid)
			window.eventsChannel.emit('thumbnailGridWasFiltered')
			$grid.removeData('filterTimeout1')
		}, 500)
		$grid.data('filterTimeout1', timeout1)
	} else if (!usesScrollAnim && layData.tgf_transition == 'fade_out_fade_in_2' && animate) {
		// fade out all thumbnails at once
		// load thumbnails that are in viewport

		$thumbs.find('.thumb').css('transitionDelay', '0ms')
		// Skip thumbs that opted out of the legacy in-view fade
		// (`no-animate-in-on-scroll` is set when the parent thumbnailgrid
		// drives its own scroll-animation system on inner wraps). Adding
		// `.below` to them would set opacity:0 via the
		// `.thumb-collection .thumb.below { opacity: 0 }` rule, and the
		// removal logic below only clears it for items currently in
		// viewport — items further down would stay invisible forever
		// because the legacy IO module also skips `.no-animate-in-on-scroll`
		// elements and wouldn't lift the class on scroll.
		$thumbs.find('.thumb:not(.no-animate-in-on-scroll)').removeClass('in-view').addClass('below')

		var timeout1 = setTimeout(function () {
			element_animate_in_on_scroll_controller.pauseOnScrollAnimation()
			reorderThumbnailsForCategory($grid, cat_id)
			showHideThumbnails(thumbnails_show_hide_data)
			limitThumbnails($grid, config)
			var $filteredThumbs = $grid.find('.show-filtered:not(.hide-because-limit) .thumb')

			// re-layout
			switch (config.layoutType) {
				case 'masonry':
					sizeLayout($grid, config)
					break
				default:
					initLayoutType($grid, config)
					sizeLayout($grid, config)
					break
			}
			utility_controller.setImageSizesAttribute($grid)
			// Reset Load More multiplier and re-evaluate Load More button visibility after filtering
			resetRowsShownMultiplier($grid)
			applyRowLimit($grid, config)

			// After applyRowLimit, get only the visible items (not hidden by hide-loadmore)
			var visibleFilteredThumbs = $grid.find('.show-filtered:not(.hide-because-limit):not(.hide-loadmore) .thumb')
			var filteredItems = visibleFilteredThumbs.toArray()
			sortByVisual(filteredItems)

			// Calculate stagger delays for fade in based on sorted position of visible items only
			const fadeInDelays = filteredItems.map((_, index) => {
				const baseDelay = 100
				const minTotalDelay = 300 // Minimum total animation time
				const delayPerItem = Math.max(baseDelay, minTotalDelay / filteredItems.length)
				return index * delayPerItem
			})

			// safety offset cause elements start out lower because animation is from down to up:
			let offset = Utility.isPhoneSize ? parseInt(layData.misc_options_scroll_transition_offset_mobile) : parseInt(layData.misc_options_scroll_transition_offset_desktop)

			// Clear transition delays for all thumbs first
			$grid.find('.thumbnail-wrap .thumb').css('transitionDelay', '')

			filteredItems.forEach((item, index) => {
				let rect = item.getBoundingClientRect()
				// only apply delay to items that are in viewport:
				if (rect.bottom > 0 && rect.top < window.innerHeight + offset) {
					item.style.transitionDelay = fadeInDelays[index] + 'ms'
				}
			})

			//waitUntilInviewImagesHaveLoaded($filteredThumbs, function () {
			// css animations - use visibleFilteredThumbs to only animate visible items
			visibleFilteredThumbs.each(function () {
				var $thumb = jQuery(this)
				if ($thumb.css('display') == 'block') {
					let rect = $thumb[0].getBoundingClientRect()
					// only apply delay to items that are in viewport:
					if (rect.bottom > 0 && rect.top < window.innerHeight + offset) {
						$thumb.removeClass('below').addClass('in-view')
					} else {
						if (layData.element_transition_on_scroll != 'on') {
							// because if we have dont have the feature element in on scroll enabled, if we dont remove the below class, the thumbnails would never be shown:
							$thumb.removeClass('below in-view')
						}
					}
				} else {
					$thumb.removeClass('below in-view')
				}
			})

			var timeout2 = setTimeout(function () {
				element_animate_in_on_scroll_controller.resumeOnScrollAnimation()
				// Re-evaluate button visibility after animation completes to ensure it's shown if needed
				applyRowLimit($grid, config)
				$grid.removeData('filterTimeout2')
			}, 500)
			$grid.data('filterTimeout2', timeout2)
			//})
			loadVideos($grid)
			window.eventsChannel.emit('thumbnailGridWasFiltered')
			$grid.removeData('filterTimeout1')
		}, 550)
		$grid.data('filterTimeout1', timeout1)
	} else {
		reorderThumbnailsForCategory($grid, cat_id)
		showHideThumbnails(thumbnails_show_hide_data)
		limitThumbnails($grid, config)

		switch (config.layoutType) {
			case 'masonry':
				sizeLayout($grid, config)
				break
			default:
				initLayoutType($grid, config)
				sizeLayout($grid, config)
				break
		}
		utility_controller.setImageSizesAttribute($grid)
		// Reset Load More multiplier and re-evaluate Load More button visibility after filtering
		resetRowsShownMultiplier($grid)
		applyRowLimit($grid, config)
		loadVideos($grid)
		window.eventsChannel.emit('thumbnailGridWasFiltered')
	}
}

var get_thumbnails_show_hide_data = function ($grid) {
	var hash = window.location.hash
	var filters = parseHashForFilters(hash)
	var cat_id = false
	var config = $grid.data('config')
	var showAllProjects = config != false && config.hasOwnProperty('showAllProjects') ? config.showAllProjects : false

	// check if all filter is active, or if show all is enabled
	var $allFilter = $grid.find('.lay-thumbnailgrid-filter-anchor[data-slug="all"].lay-filter-active')
	if (($allFilter.length > 0 && hash == '') || (showAllProjects && hash == '')) {
		cat_id = false
	} else if (filters.categorySlug) {
		var $filter = $grid.find('.lay-thumbnailgrid-filter-anchor[data-slug="' + filters.categorySlug + '"]')
		if ($filter.length > 0) {
			cat_id = parseInt($filter.attr('data-id'), 10)
		}
	} else if (hash == '') {
		// back to default filter!
		var $filter = $grid.find('.lay-filter-default')
		if ($filter.length > 0) {
			cat_id = parseInt($filter.attr('data-id'), 10)
		}

		if (cat_id === false) {
			cat_id = parseInt(config.cat_id, 10)
		}
	}

	// When "Show projects of category" is set but category filter UI is hidden, always restrict to that category (e.g. when only tag filter is used).
	// If the category filter is present, cat_id === false can intentionally mean that the user selected "All".
	var hasCategoryFilter = $grid.find('.lay-thumbnailgrid-filter-anchor').length > 0
	if (cat_id === false && !hasCategoryFilter && !showAllProjects && config != null && config.cat_id != null && config.cat_id !== '') {
		cat_id = parseInt(config.cat_id, 10)
	}

	var tag_ids_to_filter_for = []
	$grid.find('.tag-bubble.lay-tag-active').each(function () {
		var tag_id = parseInt(jQuery(this).attr('data-tag_id'), 10)
		tag_ids_to_filter_for.push(tag_id)
	})

	var $thumbs = $grid.find('.thumbnail-wrap')
	var config = $grid.data('config')

	// $thumbs, cat_id, tag_ids_to_filter_for = [], config = false
	var data = []

	var tagFilterBehaviour = 'OR'
	if (config != false && config.hasOwnProperty('tagFilterBehaviour')) {
		tagFilterBehaviour = config.tagFilterBehaviour
		tagFilterBehaviour = tagFilterBehaviour.toUpperCase()
	}

	// Get visible tag IDs if onlyShowVisibleTagFilters is enabled
	var visibleTagIds = []
	var onlyShowVisibleTagFilters = false
	if (config != false && config.hasOwnProperty('onlyShowVisibleTagFilters') && config.onlyShowVisibleTagFilters === true) {
		onlyShowVisibleTagFilters = true
		if (config.hasOwnProperty('sortedTagFilters') && Array.isArray(config.sortedTagFilters)) {
			config.sortedTagFilters.forEach(function (tag) {
				// Default to visible if not specified (backward compatibility)
				if (!tag.hasOwnProperty('visible') || tag.visible !== false) {
					visibleTagIds.push(tag.id)
				}
			})
		}
	}

	$thumbs.each(function () {
		var $thumb = jQuery(this)
		var thumbnail_tag_ids_string = $thumb.attr('data-tags')
		var thumbnail_tag_ids = utility_controller.parseIdsString(thumbnail_tag_ids_string)
		let thumbnail_cat_ids = utility_controller.parseIdsString($thumb.attr('data-filterid'))
		// add 0, for "All" filter
		thumbnail_cat_ids.push(0)

		var resultObj = {
			show: false,
			$el: $thumb,
			// i think this is not needed:
			ids: thumbnail_tag_ids,
		}

		var tagIntersection = false
		switch (tagFilterBehaviour) {
			case 'AND':
				tagIntersection = intersection(thumbnail_tag_ids, tag_ids_to_filter_for).length == tag_ids_to_filter_for.length
				break
			case 'OR':
			default:
				tagIntersection = intersection(thumbnail_tag_ids, tag_ids_to_filter_for).length > 0
				break
		}

		if (tag_ids_to_filter_for.length == 0 && cat_id !== false && thumbnail_cat_ids.indexOf(cat_id) !== -1) {
			resultObj.show = true
		} else if (tag_ids_to_filter_for.length > 0 && tagIntersection && cat_id !== false && thumbnail_cat_ids.indexOf(cat_id) !== -1) {
			resultObj.show = true
		} else if (tag_ids_to_filter_for.length > 0 && tagIntersection && cat_id === false) {
			resultObj.show = true
		} else if (cat_id === false && tag_ids_to_filter_for.length == 0) {
			resultObj.show = true
		} else {
			resultObj.show = false
		}

		// If onlyShowVisibleTagFilters is enabled, add additional constraint: thumbnail must have at least one visible tag
		// This applies as an additional filter after the category/tag selection logic
		if (onlyShowVisibleTagFilters && resultObj.show === true) {
			if (visibleTagIds.length === 0) {
				// No visible tags configured, hide all thumbnails
				resultObj.show = false
			} else {
				// Check if thumbnail has at least one visible tag
				var hasVisibleTag = intersection(thumbnail_tag_ids, visibleTagIds).length > 0
				if (!hasVisibleTag) {
					// Thumbnail doesn't have any visible tags, hide it
					resultObj.show = false
				}
			}
		}

		data.push(resultObj)
	})

	return data
}

var showHideThumbnails = function (thumbnails_show_hide_data) {
	for (var index = 0; index < thumbnails_show_hide_data.length; index++) {
		var obj = thumbnails_show_hide_data[index]
		if (obj.show == true) {
			obj.$el.css('display', 'block').addClass('show-filtered').removeClass('hide-filtered')
		} else {
			obj.$el.css('display', 'none').addClass('hide-filtered').removeClass('show-filtered')
		}
	}
}

var bindEventsToInitGrids = function () {
	window.laytheme.on('searchresultshown', function () {
		$grids = jQuery('.thumbs-collection-region')
		$grids.each(function () {
			var $el = jQuery(this)
			// doing !jQuery(this).hasClass('initialized') to prevent already initialized grids to re-initialize
			// when a page contains a thumbnailgrid, it could get re-initialized over and over every time the "searchresultshown" event is fired
			if (!jQuery(this).hasClass('initialized')) {
				var config = $el.data('config')
				initLayoutType($el, config)
				sizeLayout($el, config)
				jQuery(this).addClass('initialized sized')
				// just as a safety measure, because sometimes layoutComplete doesnt trigger
				if (config.layoutType == 'masonry') {
					$el.closest('.col').addClass('masonry-initialized')
				}
			}
			loadVideos($el)
		})
	})
}

jQuery(document).on('click', '.lay-thumbnailgrid-load-more', function (event) {
	event.preventDefault()
	var $button = jQuery(this)
	var $wrap = $button.closest('.thumbs-collection-region')
	if ($wrap.length === 0) {
		// Fallback: try to find it as a sibling (for backward compatibility)
		$wrap = $button.closest('.lay-thumbnailgrid-load-more-wrap').prevAll('.thumbs-collection-region').first()
	}
	if ($wrap.length === 0) {
		return
	}
	var config = $wrap.data('config')
	if (!config) {
		$button.hide()
		return
	}
	var rowsToShow = getRowsToShow(config, Utility.screenSize)
	if (rowsToShow <= 0) {
		$button.hide()
		return
	}
	var multiplier = getRowsShownMultiplier($wrap) + 1
	setRowsShownMultiplier($wrap, multiplier)

	// Save load more state to sessionStorage
	var elementType = restoreLoadMore.getElementType($wrap)
	var elementId = restoreLoadMore.getElementId($wrap)
	if (elementType && elementId) {
		if (restoreLoadMore.isRememberEnabled()) {
			restoreLoadMore.saveLoadMoreState(elementType, elementId, { multiplier: multiplier })
		} else {
			restoreLoadMore.clearLoadMoreState(elementType, elementId)
		}
	} else {
		console.warn('[ThumbnailGrid Load More] Could not save state - missing elementType or elementId:', {
			elementType: elementType,
			elementId: elementId,
		})
	}

	applyRowLimit($wrap, config)
	sizeLayout($wrap, config)
	utility_controller.setImageSizesAttribute($wrap)

	// Scroll animations are handled automatically by the IntersectionObserver:
	// Hidden elements already have the 'below' class from initial setup,
	// so when they become visible, the observer will automatically trigger the animation
	if (window.layData && window.layData.element_transition_on_scroll != 'on') {
		// Fallback: Remove .below class from visible thumbnails after Load More (same logic as filtering)
		var $visibleThumbs = $wrap.find('.thumbnail-wrap:not(.hide-loadmore):not(.hide-filtered):not(.hide-because-limit) .thumb')
		var offset = Utility.isPhoneSize ? parseInt(layData.misc_options_scroll_transition_offset_mobile) : parseInt(layData.misc_options_scroll_transition_offset_desktop)
		$visibleThumbs.each(function () {
			var $thumb = jQuery(this)
			if ($thumb.css('display') == 'block') {
				var rect = $thumb[0].getBoundingClientRect()
				// only remove below class from items that are in viewport:
				if (rect.bottom > 0 && rect.top < window.innerHeight + offset) {
					$thumb.removeClass('below').addClass('in-view')
				} else {
					if (layData.element_transition_on_scroll != 'on') {
						// because if we have dont have the feature element in on scroll enabled, if we dont remove the below class, the thumbnails would never be shown:
						$thumb.removeClass('below in-view')
					}
					// If element_transition_on_scroll == 'on', keep .below class so scroll controller can handle it
				}
			} else {
				$thumb.removeClass('below in-view')
			}
		})
	}

	loadVideos($wrap)
	if ($wrap.find('.thumbnail-wrap').not('.hide-filtered, .hide-because-limit, .hide-loadmore').length === $wrap.find('.thumbnail-wrap').not('.hide-filtered, .hide-because-limit').length) {
		$button.hide()
	}
})

var thumbnailgrid_controller = {
	sizeLayout: sizeLayout,
	i: i,
}

export default thumbnailgrid_controller

window.thumbnailgrid_controller = thumbnailgrid_controller
